module.exports = __webpack_public_path__ + "img/Filling-the-hotel.cea0693d.png";